<template>
  <main>
    <background-wrapper src="contact-us/fullscreen-image_background" ext="png">
      <div class="contact-us">
        <div class="contact-us__text-block">
          <h3 v-html="$t(`ContactUs.imgText.title`)"/>
          <p v-html="$t(`ContactUs.imgText.text`)"/>
          <b-btn variant="primary" href="https://app.hrdownloads.com/login">
            <span v-html="$t('routes.Login')"/>
          </b-btn>
        </div>
        <div class="contact-us__image-block">
          <img src="@/assets/contact-us/image.png"/>
        </div>
        <div class="contact-us__form-block">
          <div class="form">
            <div id="hubspotForm" v-once />
          </div>
          <p class="disclaimer" v-html="$t(`ContactUs.form.disclaimer`)"/>
        </div>
      </div>
    </background-wrapper>
  </main>
</template>

<script>
import ContentWithImage from '@/components/ui/ContentWithImage.vue'

export default {
  name: 'ContactUs',
  components: { ContentWithImage },
  mounted () {
    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/v2.js'
    document.body.appendChild(script)
    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '1890515',
          formId: '66d6ef75-ba42-4064-9936-e354d5b993c9',
          sfdcCampaignId: '7011B000002hF1SQAU',
          target: '#hubspotForm'
        })
      }
    })
  }
}
</script>

<style lang="sass" scoped>
.contact-us
  display: grid
  grid-template-columns: minmax(0, 1fr) 450px
  grid-template-rows: auto 1fr
  grid-gap: 20px 100px
  align-content: start
  align-items: start
  padding: 60px 0 80px
  +media-breakpoint-down(md)
    grid-template-columns: repeat(2, minmax(0, 1fr))
    grid-gap: 20px 40px
  +media-breakpoint-down(sm)
    grid-template-columns: minmax(0, 1fr)

  &__text-block
    grid-column-start: 1
    grid-column-end: 2

  &__image-block
    grid-column-start: 1
    grid-column-end: 2
    grid-row-start: 2
    display: flex
    align-items: center
    justify-content: center
    +media-breakpoint-down(sm)
      grid-row-start: 3

    img
      width: 85%
      +media-breakpoint-down(sm)
        width: 100%
        max-width: 250px

  &__form-block
    grid-column-start: 2
    grid-column-end: 3
    grid-row-start: 1
    grid-row-end: 3
    +media-breakpoint-down(sm)
      grid-column-start: 1
      grid-column-end: 2
      grid-row-start: 2

.disclaimer
  margin-top: 30px
  margin-bottom: 0
  padding: 0 25px
  line-height: 16px
  font-size: 12px
  +media-breakpoint-down(sm)
    margin-top: 40px

.form
  padding: 10px 30px
  background-color: #fff
  border: 1px solid #EEF1F7
  border-radius: 5px
  +media-breakpoint-down(sm)
    margin-top: 45px

</style>



// WEBPACK FOOTER //
// src/components/contactUs/ContactUs.vue